// src/pages/CampaignDashboard/PaginationControls.js

import React from 'react';

const PaginationControls = ({ currentPage, totalPages, onPrevPage, onNextPage }) => {
    return (
        <div className="flex justify-between w-full mt-2 p-2">
            <button
                onClick={onPrevPage}
                disabled={currentPage === 1}
                className="px-4 py-2 bg-gray-300 rounded-full disabled:opacity-50"
            >
                Prev
            </button>
            <div className="flex items-center">
                Page {currentPage} of {totalPages}
            </div>
            <button
                onClick={onNextPage}
                disabled={currentPage === totalPages}
                className="px-4 py-2 bg-gray-300 rounded-full disabled:opacity-50"
            >
                Next
            </button>
        </div>
    );
};

export default PaginationControls;